import { render, staticRenderFns } from "./ModalView.vue?vue&type=template&id=46fba6cc"
import script from "./ModalView.vue?vue&type=script&lang=js"
export * from "./ModalView.vue?vue&type=script&lang=js"
import style0 from "./ModalView.vue?vue&type=style&index=0&id=46fba6cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports